import { useSyncExternalStore } from 'react';

/**
 * Subscribes to a CSS media query. SSR-safe (false until mounted).
 * @param {string} query e.g. '(max-width: 1024px)'
 */
export function useMatchMedia(query) {
    return useSyncExternalStore(
        (onStoreChange) => {
            if (typeof window === 'undefined') return () => {};
            const mql = window.matchMedia(query);
            mql.addEventListener('change', onStoreChange);
            return () => mql.removeEventListener('change', onStoreChange);
        },
        () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false),
        () => false,
    );
}
